import type { CarouselSlide } from '../../types/product'

export const CAROUSEL_SLIDES: CarouselSlide[] = [
  {
    slide_id: '1',
    title: 'Fresh Produce Sale',
    subtitle: 'Up to 30% Off on Fruits & Vegetables',
    image_url: 'https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=1200&h=400&fit=crop&q=80',
    mobile_image_url: 'https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=800&h=300&fit=crop&q=80',
    cta_text: 'Shop Fresh',
    cta_link: '/products?category=fresh-produce',
    background_color: '#2E7D32',
    start_date: new Date().toISOString(),
    end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    priority: 1,
    target_audience: ['BD', 'IN', 'PK'],
  },
  {
    slide_id: '2',
    title: 'Weekly Grocery Deals',
    subtitle: 'Save Big on Everyday Essentials',
    image_url: 'https://images.unsplash.com/photo-1543168256-418811576931?w=1200&h=400&fit=crop&q=80',
    mobile_image_url: 'https://images.unsplash.com/photo-1543168256-418811576931?w=800&h=300&fit=crop&q=80',
    cta_text: 'View Deals',
    cta_link: '/products?sort=discount_desc',
    background_color: '#FF5722',
    start_date: new Date().toISOString(),
    end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    priority: 2,
    target_audience: ['BD', 'IN', 'PK'],
  },
  {
    slide_id: '3',
    title: 'Free Delivery',
    subtitle: 'On Orders Over 500 BDT',
    image_url: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=1200&h=400&fit=crop&q=80',
    mobile_image_url: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=800&h=300&fit=crop&q=80',
    cta_text: 'Start Shopping',
    cta_link: '/products',
    background_color: '#1565C0',
    start_date: new Date().toISOString(),
    end_date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
    priority: 3,
    target_audience: ['BD', 'IN', 'PK'],
  },
  {
    slide_id: '4',
    title: 'Fresh Dairy Arrivals',
    subtitle: 'Farm Fresh Milk, Eggs & More',
    image_url: 'https://images.unsplash.com/photo-1550583724-b2692b85b150?w=1200&h=400&fit=crop&q=80',
    mobile_image_url: 'https://images.unsplash.com/photo-1550583724-b2692b85b150?w=800&h=300&fit=crop&q=80',
    cta_text: 'Shop Dairy',
    cta_link: '/products?category=dairy-eggs',
    background_color: '#00796B',
    start_date: new Date().toISOString(),
    end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    priority: 4,
    target_audience: ['BD'],
  },
  {
    slide_id: '5',
    title: 'Bakery Fresh',
    subtitle: 'Freshly Baked Bread & Pastries',
    image_url: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=1200&h=400&fit=crop&q=80',
    mobile_image_url: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=800&h=300&fit=crop&q=80',
    cta_text: 'Shop Bakery',
    cta_link: '/products?category=bakery',
    background_color: '#8D6E63',
    start_date: new Date().toISOString(),
    end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    priority: 5,
    target_audience: ['BD', 'IN', 'PK'],
  },
  {
    slide_id: '6',
    title: 'Pantry Essentials',
    subtitle: 'Stock Up on Rice, Oil & Spices',
    image_url: 'https://images.unsplash.com/photo-1556909212-d5b604d0c90d?w=1200&h=400&fit=crop&q=80',
    mobile_image_url: 'https://images.unsplash.com/photo-1556909212-d5b604d0c90d?w=800&h=300&fit=crop&q=80',
    cta_text: 'Shop Pantry',
    cta_link: '/products?category=pantry-staples',
    background_color: '#F57C00',
    start_date: new Date().toISOString(),
    end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    priority: 6,
    target_audience: ['BD', 'IN', 'PK'],
  },
  {
    slide_id: '7',
    title: 'Frozen Food Festival',
    subtitle: 'Ice Cream, Ready Meals & More',
    image_url: 'https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=1200&h=400&fit=crop&q=80',
    mobile_image_url: 'https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=800&h=300&fit=crop&q=80',
    cta_text: 'Shop Frozen',
    cta_link: '/products?category=frozen-foods',
    background_color: '#0288D1',
    start_date: new Date().toISOString(),
    end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    priority: 7,
    target_audience: ['BD', 'IN', 'PK'],
  },
  {
    slide_id: '8',
    title: 'Beverages & Drinks',
    subtitle: 'Refreshing Drinks for Every Occasion',
    image_url: 'https://images.unsplash.com/photo-1437418747212-8d9709afab22?w=1200&h=400&fit=crop&q=80',
    mobile_image_url: 'https://images.unsplash.com/photo-1437418747212-8d9709afab22?w=800&h=300&fit=crop&q=80',
    cta_text: 'Shop Beverages',
    cta_link: '/products?category=beverages',
    background_color: '#7B1FA2',
    start_date: new Date().toISOString(),
    end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    priority: 8,
    target_audience: ['BD', 'IN', 'PK'],
  },
]
